import { QuizQuestion } from '../../api/quiz-services';

export const assessmentMetadata = {
    title: "Space Management Systems Quiz",
    duration: 15
};

export const module5Questions: QuizQuestion[] = [
    {
        id: "M5-001",
        moduleId: "module-5",
        category: "Strategy",
        text: "The S.E.E. Strategy stands for ____.",
        options: ["Signal, Enter, Exit", "Search, Evaluate, Execute", "Scan, Evaluate, Exit", "Stop, Examine, Enter"],
        correctAnswer: 1,
        scenario: "The **S.E.E. Strategy** stands for **Search, Evaluate, and Execute**. It is a proactive decision-making cycle designed to help you scan the environment, identify risks early, and make safe physical driving adjustments to avoid collisions before they happen.",
        explanation: ""
    },
    {
        id: "M5-002",
        moduleId: "module-5",
        category: "Strategy",
        text: "As part of the Search phase, you should look ____ seconds ahead.",
        options: ["5", "10", "15", "30"],
        correctAnswer: 2,
        scenario: "You are scanning your path of travel and want to calculate your visual search lead time. How far ahead should you look?",
        explanation: "Searching 15 seconds ahead provides a visual lead time that allows your brain to process traffic patterns, anticipate conflicts, and make gradual adjustments."
    },
    {
        id: "M5-003",
        moduleId: "module-5",
        category: "Scanning",
        text: "To maintain the 'Big Picture', you should scan your mirrors every ____ seconds.",
        options: ["2-3", "5-8", "15-20", "Only when stopping"],
        correctAnswer: 1,
        scenario: "To maintain complete 360-degree awareness, how often should you scan your mirrors and check your instrument panel?",
        explanation: "Safety guidelines recommend checking your mirrors and dashboard indicators every 5 to 8 seconds to prevent fixed-stare hazards and maintain situational awareness."
    },
    {
        id: "M5-004",
        moduleId: "module-5",
        category: "Scanning",
        text: "Looking at the front tires of parked cars to predict their movement is called ____.",
        options: ["Tire-gazing", "Ground Viewing", "Sidewalk scanning", "Wheel auditing"],
        correctAnswer: 1,
        scenario: "You are driving past a row of parked cars in a busy residential area. Where should you scan to predict if a car is about to pull out?",
        explanation: "Scanning the front tires of parked cars (ground viewing) allows you to detect wheel angles and rotation immediately, warning you that a vehicle is about to enter your path before the vehicle body itself moves."
    },
    {
        id: "M5-005",
        moduleId: "module-5",
        category: "Strategy",
        text: "The 'Evaluate' phase involves asking yourself ____.",
        options: ["Where am I?", "What time is it?", "'What if?' (Predicting outcomes)", "How fast is that car?"],
        correctAnswer: 2,
        scenario: "A thorough pre-drive walk-around allows you to identify **flat tires, fluid leaks, and any people, animals, or objects** hidden in your path of travel. Checking these before starting the engine prevents catastrophic tire blowouts, engine damage from fluid starvation, and tragic back-over accidents.",
        explanation: ""
    },
    {
        id: "M5-006",
        moduleId: "module-5",
        category: "Strategy",
        text: "The Smith System Key 'Aim High in Steering' means looking ____.",
        options: ["At the sky", "15 seconds ahead", "At your visor", "Only at the car in front"],
        correctAnswer: 1,
        scenario: "You are driving down a busy city street and want to apply the first Smith System Key: Aim High in Steering. Where should you look?",
        explanation: "Aiming high means looking 15 seconds down your intended path, which shifts your focus from the road directly in front to the horizon, allowing you to anticipate hazards early."
    },
    {
        id: "M5-007",
        moduleId: "module-5",
        category: "Strategy",
        text: "The Smith System Key 'Leave Yourself An Out' refers to maintaining a ____.",
        options: ["Spare tire", "Space cushion", "Full tank of gas", "GPS routeing"],
        correctAnswer: 1,
        scenario: "Applying the second Smith System Key: Get the Big Picture. What should you establish around your vehicle?",
        explanation: "Getting the big picture means maintaining a 360-degree space cushion around your vehicle, keeping you aware of merging cars, cyclists, and changing lane conditions."
    },
    {
        id: "M5-008",
        moduleId: "module-5",
        category: "Strategy",
        text: "Which Smith System Key emphasizes making eye contact and using signals?",
        options: ["Aim High", "Keep Eyes Moving", "Make Sure They See You", "Big Picture"],
        correctAnswer: 2,
        scenario: "You are preparing to change lanes in heavy highway traffic. Which Smith System Key is most critical here?",
        explanation: "Making sure others see you involves using signals early, establishing eye contact, and tapping your horn or flashing lights if needed to communicate your presence on the Grid."
    },
    {
        id: "M5-009",
        moduleId: "module-5",
        category: "Strategy",
        text: "How often should you move your eyes to avoid fixed-stare 'tunnel vision'?",
        options: ["Every 2 seconds", "Every 10 seconds", "Only at intersections", "Never"],
        correctAnswer: 0,
        scenario: "You are driving on a long, monotonous straightaway and want to avoid highway hypnosis or a fixed stare. What is the rule?",
        explanation: "The 'Keep Eyes Moving' key mandates shifting your visual target every 2 seconds, scanning mirrors, cross-traffic, and lane markings to prevent fatigue and fixed-stare blindness."
    },
    {
        id: "M5-010",
        moduleId: "module-5",
        category: "Risk",
        text: "Inattentional blindness is often caused by ____.",
        options: ["Poor eyesight", "Cognitive Tunneling (High stress/emotion)", "Bad headlights", "Tinted windows"],
        correctAnswer: 1,
        scenario: "A classmate asks why talking on a cell phone, even hands-free, increases collision risk so heavily.",
        explanation: "Cognitive distractions (like phone calls) overload the brain's processing capacity, causing 'inattentional blindness' where a driver physically looks at a hazard but fails to perceive it."
    },
    {
        id: "M5-011",
        moduleId: "module-5",
        category: "Strategy",
        text: "Safe driving is more about ____ than it is about reaction time.",
        options: ["Mechanical skill", "Prevention and anticipation", "Speed", "Braking power"],
        correctAnswer: 1,
        scenario: "A passenger suggests that a driver with exceptionally fast physical reaction times is the safest pilot. Is this true?",
        explanation: "Real driving safety relies far more on hazard prevention and anticipation than on rapid reaction times. Proactive space management eliminates the need for emergency, high-risk maneuvers."
    },
    {
        id: "M5-012",
        moduleId: "module-5",
        category: "Strategy",
        text: "A 'space cushion' should be maintained on ____ sides of the vehicle.",
        options: ["Front and back only", "Left and right only", "All four", "Just the front"],
        correctAnswer: 2,
        scenario: "A thorough pre-drive walk-around allows you to identify **flat tires, fluid leaks, and any people, animals, or objects** hidden in your path of travel. Checking these before starting the engine prevents catastrophic tire blowouts, engine damage from fluid starvation, and tragic back-over accidents.",
        explanation: ""
    },
    {
        id: "M5-013",
        moduleId: "module-5",
        category: "Strategy",
        text: "When you 'Evaluate' a ball rolling into the street, you should predict ____.",
        options: ["The ball will stop", "A child will follow it", "The wind is blowing", "The ball is red"],
        correctAnswer: 1,
        scenario: "When you see a ball roll into the street, you must **Evaluate** the high-risk potential and predict that **a child will chase after it**. This foresight allows you to proactively cover the brake and reduce speed before the hazard even fully reveals itself.",
        explanation: ""
    },
    {
        id: "M5-014",
        moduleId: "module-5",
        category: "Strategy",
        text: "Under the 'Execute' phase, which action might you take to reduce risk?",
        options: ["Change lane position", "Adjust speed", "Communicate with a signal", "Any of the above"],
        correctAnswer: 3,
        scenario: "You are scanning an active residential block and see a ball roll out from between parked cars. What is your first priority under the S.E.E. system?",
        explanation: "S.E.E. stands for Search, Evaluate, and Execute. Seeing the ball is the Search. You must instantly Evaluate—predicting that a child will chase the ball—so you can proactively reduce speed before the hazard emerges."
    },
    {
        id: "M5-015",
        moduleId: "module-5",
        category: "Risk",
        text: "Visual Tunneling narrows your peripheral vision to focus on the ____.",
        options: ["Dashboard", "Immediate path ahead", "Rearview mirror", "License plates"],
        correctAnswer: 1,
        scenario: "You are driving under extreme stress or at high speeds. A passenger notices your eyes are locked on the lane directly in front. What is this hazard?",
        explanation: "Visual Tunneling narrows your peripheral field under stress, locking your gaze to the immediate path ahead. You must force your eyes to move to rebuild 360-degree awareness."
    },
    {
        id: "M5-016",
        moduleId: "module-5",
        category: "Strategy",
        text: "A 'Platinum Driver' manages risk through a ____.",
        options: ["Fast car", "Disciplined mental cycle", "Luck", "Expensive insurance"],
        correctAnswer: 1,
        scenario: "A thorough pre-drive walk-around allows you to identify **flat tires, fluid leaks, and any people, animals, or objects** hidden in your path of travel. Checking these before starting the engine prevents catastrophic tire blowouts, engine damage from fluid starvation, and tragic back-over accidents.",
        explanation: ""
    },
    {
        id: "M5-017",
        moduleId: "module-5",
        category: "Scanning",
        text: "Scanning includes checking the ____, the sides, and the rear.",
        options: ["Radio", "Horizon (15 seconds ahead)", "Glove box", "Floor mats"],
        correctAnswer: 1,
        scenario: "You are driving in heavy city traffic and want to scan your environment thoroughly. Where should your visual sweeps lead?",
        explanation: "Scanning is a systematic sweep that moves from the deep horizon (15 seconds ahead) to your vehicle's sides, mirrors, and dashboard instruments, ensuring complete coverage."
    },
    {
        id: "M5-018",
        moduleId: "module-5",
        category: "Communication",
        text: "Making it easy for others to see you is part of the ____.",
        options: ["State law", "Social contract of driving", "Insurance policy", "Vite protocol"],
        correctAnswer: 1,
        scenario: "A driver next to you changes lanes without signaling, forcing you to brake. Why is this a violation under defensive driving guidelines?",
        explanation: "Making it easy for others to see you and predict your movements fulfills the 'Social Contract' of driving, maintaining the cooperative balance of the Grid."
    },
    {
        id: "M5-019",
        moduleId: "module-5",
        category: "Strategy",
        text: "In the S.E.E. loop, which step involves physical movement of the vehicle?",
        options: ["Search", "Evaluate", "Execute", "Scan"],
        correctAnswer: 2,
        scenario: "You have searched for a hazard and evaluated its risk. Now you must physically steer or brake to avoid it. Which phase is this?",
        explanation: "The physical movement of your vehicle—whether braking, accelerating, or steering laterally—constitutes the 'Execute' phase of the Search, Evaluate, and Execute cycle."
    },
    {
        id: "M5-020",
        moduleId: "module-5",
        category: "Strategy",
        text: "Aiming high in steering helps you avoid ____.",
        options: ["Low-hanging branches", "Last-second 'emergency' maneuvers", "Potholes only", "High beam glare"],
        correctAnswer: 1,
        scenario: "You are driving and want to understand how 'Aiming High in Steering' physically protects your vehicle on the roadway.",
        explanation: "Aiming high in steering expands your field of view, providing the time needed to make gradual adjustments and completely avoiding high-risk, last-second 'emergency' maneuvers."
    },
    {
        id: "M5-021",
        moduleId: "module-5",
        category: "Physics",
        text: "How does doubling your vehicle's speed affect its kinetic energy and braking distance?",
        options: [
            "Kinetic energy and braking distance are doubled (2x)",
            "Kinetic energy and braking distance are tripled (3x)",
            "Kinetic energy and braking distance are quadrupled (4x)",
            "Kinetic energy remains the same"
        ],
        correctAnswer: 2,
        scenario: "**Correct Action**: **Kinetic energy increases with the square of speed. Doubling your vehicle speed quadruples (4x) its kinetic energy and multiplies your physical braking stopping distance by four times.**",
        explanation: ""
    },
    {
        id: "M5-022",
        moduleId: "module-5",
        category: "Physics",
        text: "What is 'inertia' in driving physics?",
        options: [
            "The engine's horsepower output",
            "The force that pulls a vehicle down a hill",
            "The tendency of an object to resist changes in its state of motion (e.g., continuing straight in a curve)",
            "The friction coefficient of tires"
        ],
        correctAnswer: 2,
        scenario: "**Correct Action**: **Inertia is the physical tendency of objects in motion to remain in motion in a straight line. When steering into a curve, inertia forces the car and occupants straight, requiring tire friction to pull them around.**",
        explanation: ""
    },
    {
        id: "M5-023",
        moduleId: "module-5",
        category: "Friction",
        text: "Which factor has the greatest influence on a tire's traction with the road surface?",
        options: [
            "The vehicle's paint finish",
            "The quality and depth of the tire tread and the roadway condition",
            "The car's stereo system",
            "The size of the fuel tank"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Tire traction depends directly on the quality and depth of the rubber tread and the condition of the road surface (e.g., wet, icy, gravel). Slick tires or standing water drastically reduce friction.**",
        explanation: ""
    },
    {
        id: "M5-024",
        moduleId: "module-5",
        category: "Gravity",
        text: "When driving downhill, how does gravity affect your vehicle?",
        options: [
            "It decreases your stopping distance",
            "It accelerates your vehicle, requiring earlier and firmer braking to maintain control",
            "It improves your steering responsiveness",
            "It does not affect vehicle speed"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Gravity pulls your vehicle down hill, accelerating the car and increasing your physical stopping distance. Earlier, firmer brake pressure is required to maintain a safe speed.**",
        explanation: ""
    },
    {
        id: "M5-025",
        moduleId: "module-5",
        category: "Performance",
        text: "What is 'perception time' in relation to total stopping distance?",
        options: [
            "The time it takes to physically move your foot to the brake pedal",
            "The time it takes for your brain to recognize a hazard and identify a threat",
            "The time it takes for the brakes to lock up",
            "The time spent checking side mirrors"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Perception time is the duration it takes for your eyes to see a hazard and your brain to cognitively identify it as a threat, which precedes reaction time and actual physical braking.**",
        explanation: ""
    }
];
